import React from 'react';
import { Stack, VStack } from '@chakra-ui/react';
import { useProposalsList, useTransactions } from 'hooks';

import { Proposals, Transactions } from './components';

const Withdraws: React.FC = () => {
  const {
    data: transactions,
    isLoading: loadingTransactions,
    refetch: refreshTransactions,
  } = useTransactions({
    queries: { 'transaction_method.category': 'WITHDRAW_LD' },
  });
  const {
    data: proposals,
    isLoading: loadingProposals,
    refetch: refetchProposals,
  } = useProposalsList({
    transaction_method_category: 'WITHDRAW_LD',
  });

  return (
    <Stack my={4} w="100%">
      <VStack
        display="flex"
        w="100%"
        py={8}
        px={4}
        gap={25}
        bgColor="dark"
        align="flex-start"
      >
        <Transactions
          transactions={transactions?.list || []}
          loading={loadingTransactions}
          refetch={refreshTransactions}
        />
        <Proposals
          proposals={proposals?.list || []}
          loading={loadingProposals}
          refetch={refetchProposals}
        />
      </VStack>
    </Stack>
  );
};

export default Withdraws;
